import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@core/material.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslocoModule } from '@jsverse/transloco';
import { JobDialogFormComponent } from './components/job-dialog-form/job-dialog-form.component';
import { JobListComponent } from './components/job-list/job-list.component';
import { JobDialogComponent } from './containers/job-dialog/job-dialog.component';
import { JobManagementWrapperComponent } from './containers/job-management-wrapper/job-management-wrapper.component';
import { JobManagementEffects, jobManagementFeature } from './store';
import { KpGlobalSearchInputComponent } from '@keeps-platform-frontend-workspace/ui/kp-global-search-input';
import { KpPluralizeTranslatePipe } from '@keeps-platform-frontend-workspace/ui/kp-pluralize-translate';

@NgModule({
  declarations: [JobManagementWrapperComponent, JobListComponent, JobDialogComponent, JobDialogFormComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    MaterialModule,
    ReactiveFormsModule,
    StoreModule.forFeature(jobManagementFeature),
    EffectsModule.forFeature(JobManagementEffects),
    KpGlobalSearchInputComponent,
    KpPluralizeTranslatePipe,
  ],
  exports: [JobManagementWrapperComponent],
})
export class JobManagementModule {}
